/* global jQuery, YT */
(() => {
  const yt_testing = false;
  const videos = Array.prototype.slice.call(document.querySelectorAll('.video-banner'));

  videos.forEach((video) => {
    const videoWidth = video.offsetWidth;
    const videoHeight = video.offsetHeight;
    const iframe = video.querySelector('iframe');

    video.addEventListener('click', () => {
      const { src } = iframe;
      video.querySelector('.video-banner__content').style.display = 'none';
      video.querySelector('.video-banner__video').style.display = 'block';
      video.querySelector('.video-banner__video').style.height = `${videoHeight}px`;
      video.querySelector('.video-banner__video iframe').style.height = `${videoHeight}px`;

      iframe.src += '&autoplay=1';

      // if (video.classList.contains('video-banner--full')) {
      //   video.querySelector('.video-banner__video').style.width = `${videoWidth}px`;
      //   video.querySelector('.video-banner__video iframe').style.width = `${videoWidth}px`;
      // } else {
        // video.querySelector('.video-banner__video').style.width = '700px';
        // video.querySelector('.video-banner__video iframe').style.width = '700px';
      // }

      if (is_youtube_iframe_api_ready()) {
        setup_youtube_embeds();
      } else {
        check_for_youtube_embeds();
      }
    });
  });

  //https://stackoverflow.com/questions/3452546/how-do-i-get-the-youtube-video-id-from-a-url
  //Get youtube video id from a string
  function get_youtube_url (url) {
    var regExp = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#\&\?]*).*/;
    var match = url.match(regExp);
    if (match && match[7].length == 10) {
      match[7] = 'v' + match[7];
    }
    return (match && match[7].length == 11) ? match[7] : false;
  }

  //Find youtube embeds on page, if there are any, then load in the youtube api library
  function check_for_youtube_embeds () {
    if (jQuery('iframe[src*="youtube.com"]').length > 0) {
      var tag = document.createElement('script');
      tag.src = 'https://www.youtube.com/player_api';
      var firstScriptTag = document.getElementsByTagName('script')[0];
      firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
      return true;
    } else {
      return false;
    }
  }

  //https://stackoverflow.com/questions/18139277/loading-youtube-api-in-jquery
  //Check for the youtube variable. Typically this will be present if the library has been loaded already
  function is_youtube_iframe_api_ready () {
    if ((typeof YT !== 'undefined') && YT && YT.Player) {
      return true;
    } else {
      return false;
    }
  }

  //Store a reference to the player in this object
  var yt_player = [];

  //Find all iframe elements on page that haven't been tracked yet, get some information about them and set them up so they can be tracked.
  function setup_youtube_embeds () {
    jQuery('iframe[src*="youtube.com"]:not(.yt-controlled)').each(function (index, element) {
      try {
        var t = jQuery(this);
        var yt_source = t.attr('src');
        var yt_id = get_youtube_url(t.attr('src'));
        var yt_height = t.attr('height');
        var yt_width = t.attr('width');

        //Create unique id for iframe
        var timestamp = +new Date();
        var yt_unique = 'yt-wrapper' + timestamp;
        t.wrap('<div id="' + yt_unique + '"></div>');

        //For .event-enable-video
        var yt_autoplay = 0;
        if (t.classList.includes('yt-autoplay')) {
          yt_autoplay = 1;
        }

        //https://developers.google.com/youtube/iframe_api_reference
        yt_player[yt_unique] = new YT.Player(yt_unique, {
          height: yt_height,
          width: yt_width,
          videoId: yt_id,
          playerVars: {
            'autoplay': yt_autoplay,
            'rel': 0,
            'modestbranding': 1,
          }, //https://developers.google.com/youtube/player_parameters
          events: {
            'onReady': onPlayerReady,
            'onStateChange': onPlayerStateChange,
          },
        });

        //Add class to iframe so it isn't re-added to the tracking later
        jQuery('#' + yt_unique).addClass('yt-controlled');
      } catch (err) {
        console.log(err);
      } //catch
    });
  }

  //The youtube api javascript is loaded
  function onYouTubeIframeAPIReady () {
    setup_youtube_embeds();
  }

  //The youtube player is ready
  function onPlayerReady (event) {
    //console.log("Ready")
    event.player.unMute();
  }

  //The state of the player has changed
  function onPlayerStateChange (event) {
    try {
      var video_id = jQuery(event.target.a).attr('id'); //Get HTML ID of video
      var video_url = 'https://www.youtube.com/watch?v=' + event.target.getVideoData().video_id; //player[video_id].getVideoUrl(); //Get URL by id for video
      var video_title = event.target.getVideoData().title;
      var video_current_time = Math.round(yt_player[video_id].getCurrentTime());
      var video_ga = video_title + ' - ' + video_url + ' - Time: ' + video_current_time;

      if (yt_testing) console.log(event.target.getVideoData());

      if (event.data == YT.PlayerState.PLAYING) {
        if (yt_testing) {
          console.log('Played', video_ga);
        } else {
          ga_track('video', 'played', video_ga);
        }
      }

      if (event.data == YT.PlayerState.PAUSED) {
        if (yt_testing) {
          console.log('Paused', video_ga);
        } else {
          ga_track('video', 'paused', video_ga, video_current_time);
        }
      }

      if (event.data == YT.PlayerState.ENDED) {
        if (yt_testing) {
          console.log('Ended', video_ga);
        } else {
          ga_track('video', 'ended', video_ga);
        }
      }

    } catch (err) {
      if (yt_testing == false) {
        ga_track('video', 'error', err);
      }
    }
  }
})();
